import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { DefaultFilter } from './default-filter.interface';

export class DefaultFilterService {
   async getDefaultFilters() {
      throw Error('Method not implemented');
   }

   async getDefaultFilter(teamId: number) {
      const response = await http.get(`/teams/${teamId}/default-filters`);
      return response.data;
   }

   async postDefaultFilter(teamId: number, defaultFilters: Array<DefaultFilter>) {
      const response = await http.post<ApiResource<DefaultFilter>>(`/teams/${teamId}/default-filters`, defaultFilters);
      return response.data;
   }

   async putDefaultFilter() {
      throw Error('Method not implemented');
   }

   async deleteDefaultFilter(teamId: number) {
      const response = await http.delete(`/teams/${teamId}/default-filters`);
      return response.data;
   }
}
